module.exports = __webpack_public_path__ + "images/interview-Boston_Consulting_Group-2.svg";